export const buildInfo = {
  branch: 'main',
  commit: '47f519d',
  buildDate: '2026-11-04T13:25:33.500Z',
};
